import { render, staticRenderFns } from "./IconButtonCard.vue?vue&type=template&id=d1415e14"
import script from "./IconButtonCard.vue?vue&type=script&lang=js"
export * from "./IconButtonCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports